import { render, staticRenderFns } from "./DeactivateReleaseButton.vue?vue&type=template&id=5202cabe"
import script from "./DeactivateReleaseButton.vue?vue&type=script&lang=js"
export * from "./DeactivateReleaseButton.vue?vue&type=script&lang=js"
import style0 from "./DeactivateReleaseButton.vue?vue&type=style&index=0&id=5202cabe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports